export enum ApplicationFeature {
  ACCOUNT_SETTINGS = 'ACCOUNT_SETTINGS',
  WALLBOX = 'CHARGEPOINT',
  WALLBOX_START_STOP_CHARGING = 'CHARGEPOINT_START_STOP',
  WALLBOX_SETTINGS = 'CHARGEPOINT_SETTINGS',
  WALLBOX_FIRMWARE_UPDATE = 'CHARGEPOINT_FIRMWARE_UPDATE',
  CHARGING_PROFILES_MANAGEMENT = 'CHARGING_PROFILES_MANAGEMENT',
}
